import { useEffect, useMemo, useState } from "react";
import { useProfileStore } from "../../../stores/UserStore";
import { useLanguage } from "../../../stores/LanguageStore";
import { updateSelf } from "../../../api/UserAPI";
import {
  Divider,
  Group,
  LoadingOverlay,
  Progress,
  RingProgress,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { IconDeviceMobile, IconUserSearch } from "@tabler/icons-react";
import { IconLinkedin } from "../../../components/Icons/IconLinkedin";
import { IconEmail } from "../../../assets/icons/IconEmail";

const HeaderStatsMobile = () => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);

  const [loading, setLoading] = useState(false);

  const linkedinAccounts = useMemo(() => {
    return profile?.permissions?.find(
      (x) => x.name === "maxIntegrationsLinkedin"
    );
  }, [profile]);
  const emails = useMemo(() => {
    return profile?.permissions?.find(
      (x) => x.name === "maxIntegrationsEmailSMTP"
    );
  }, [profile]);
  const enrichments = useMemo(() => {
    return profile?.permissions?.find(
      (x) => x.name === "maxEmailsGeneratedPerMonth"
    );
  }, [profile]);
  const mobilePhones = useMemo(() => {
    return profile?.permissions?.find(
      (x) => x.name === "maxMobilePhonesGeneratedPerMonth"
    );
  }, [profile]);

  useEffect(() => {
    setLoading(true);
    updateSelf(true).finally(() => setLoading(false));
  }, []);

  return (
    <Stack px={"sm"} gap={"xs"} py={8} pos={"relative"} justify="space-between">
      <LoadingOverlay visible={loading} loaderProps={{ size: 24 }} />

      <Group pos={"relative"}>
        <ThemeIcon size={"md"} variant="subtle" color="yellow">
          <IconEmail size={18} />
        </ThemeIcon>
        <Progress
          value={((emails?.value - emails?.remaining) / emails?.value) * 100}
          color={emails?.remaining <= 0 ? "red" : "green"}
          flex={1}
          mb={-16}
        />

        <Text pos={"absolute"} top={-4} right={0} size="xs">
          {emails?.value - emails?.remaining} / {emails?.value}
        </Text>
      </Group>

      <Divider opacity={0.25} />

      <Group pos={"relative"}>
        <ThemeIcon size={"md"} variant="subtle" color="yellow">
          <IconLinkedin size={18} />
        </ThemeIcon>
        <Progress
          value={
            ((linkedinAccounts?.value - linkedinAccounts?.remaining) /
              linkedinAccounts?.value) *
            100
          }
          color={linkedinAccounts?.remaining <= 0 ? "red" : "green"}
          flex={1}
          mb={-16}
        />
        <Text pos={"absolute"} top={-4} right={0} size="xs">
          {linkedinAccounts?.value - linkedinAccounts?.remaining} /{" "}
          {linkedinAccounts?.value}
        </Text>
      </Group>

      <Divider opacity={0.25} />

      <Group pos={"relative"}>
        <ThemeIcon size={"md"} variant="subtle" color="yellow">
          <IconUserSearch size={18} />
        </ThemeIcon>
        <Progress
          value={
            ((enrichments?.value - enrichments?.remaining) /
              enrichments?.value) *
            100
          }
          color={enrichments?.remaining <= 0 ? "red" : "green"}
          flex={1}
          mb={-16}
        />
        <Text pos={"absolute"} top={-4} right={0} size="xs">
          {enrichments?.value - enrichments?.remaining} / {enrichments?.value}
        </Text>
      </Group>

      <Divider opacity={0.25} />

      <Group pos={"relative"}>
        <ThemeIcon size={"md"} variant="subtle" color="yellow">
          <IconDeviceMobile size={18} />
        </ThemeIcon>
        <Progress
          value={
            ((mobilePhones?.value - mobilePhones?.remaining) /
              mobilePhones?.value) *
            100
          }
          color={mobilePhones?.remaining <= 0 ? "red" : "green"}
          flex={1}
          mb={-16}
        />
        <Text pos={"absolute"} top={-4} right={0} size="xs">
          {mobilePhones?.value - mobilePhones?.remaining} /{" "}
          {mobilePhones?.value}
        </Text>
      </Group>
    </Stack>
  );
};

export default HeaderStatsMobile;
